/**
 * Метка области вертикальной прокрутки, внутри которой стоят виртуальные списки
 * экрана — таблица и карточки (design stage9-table-virtual Д1,
 * stage9-cards-virtual).
 */
export const LIST_SCROLL_ATTRIBUTE = "data-list-scroll";
